module.exports = __webpack_public_path__ + "static/img/LogoMondonex_branca.015dfb1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/LogoMondonex_branca.svg
// module id = sF9t
// module chunks = 26